import { useIdleSessionTimeout } from '../hooks/useIdleSessionTimeout.js';

/**
 * Mounts idle session guard when user is authenticated (inside AppToastProvider).
 */
export default function SessionIdleGuard() {
  useIdleSessionTimeout();
  return null;
}
